import { Component } from 'react';
import LoadOrder from './LoadOrder';
import { apiGetP } from '../../GanjiTools';
import './OrdersBoard.css';
import Inline from '../Inline';
import MinimalButton from '../MinimalButton';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import { Button, CheckBox, Form, NumberBox } from 'devextreme-react';
import { UniGrid } from '../UniGrid';
import { isMobile } from 'react-device-detect';
import Spinner from '../utils/Spinner';
import Theme from '../theme/Theme';
import StepCounter from '../utils/StepCounter';
import { Label, SimpleItem } from 'devextreme-react/form';

class OrdersBoard extends Component {
    state = {
        userRole: this.props.userRole ?? 'driver',
        collapsed: true,
        mode: this.props.mode ?? 'cards',
        userText: this.props.userText ?? '',
        loading: true,
    }

    // loadEnumsP = () => new Promise((resolve, reject) => {
    //     apiGetP(`/api/rahKala/enums`)
    //         .then(res => {
    //             res ??= {};
    //             console.log('enums are loaded:');
    //             console.log(res);
    //             //     name: x.name, comment: x.comment, package: x.package,
    //             //     fromCity: x.paFromLocation?.city,
    //             //     toCityTons: x.tempCol.destinations?.reduce((a, b) => `${a} + ${b.tocityname}: ${b.tonnage}`, '')?.substr(3) + ' تن',
    //             //     tenderEndTarikh: x.tenderEndTarikh,
    //             //     statusName: x.statusName,
    //             //     truckTypes: x.truckTypes?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
    //             //     truckSpecs: x.truckSpecs?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
    //             //     companyNames: x.tempCol.companies?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
    //             //     loadingTimeFrom: x.tempCol.loadingTimeFrom,
    //             //     loadingTimeTo: x.tempCol.loadingTimeTo,
    //             //     fromProvinceId: 0,
    //             //     fromCityId: 0,
    //             //     destinations: x.tempCol.destinations,
    //             //     companies: x.tempCol.companies,
    //             //     companyIds: x.tempCol.companyIds,
    //             // }));

    //             // let orders = res.map(x => ({ ...x.loadOrder, ...x.tempCol, links: x.links }));
    //             // console.log(orders);
    //             resolve(res);
    //         })
    //         .catch(reject)
    // });

    loadDataP = () => new Promise((resolve, reject) => {
        let role = this.state.userRole;
        //apiGetP(`/api/rahKala/orderLinks/${role}?${role}Id=${this.props.userId ?? 0}&status=${this.props.status ?? ''}`)
        apiGetP(`/api/rahKala/orderLinks/${role}?companyId=${-1}&username=${this.props.userId ?? 0}&status=${this.props.status ?? ''}`)
            .then(res => {
                res ??= [];
                console.log('LoadOrders are loaded:');
                console.log(res);
                // var list = res.map(x => ({
                //     name: x.name, comment: x.comment, package: x.package,
                //     fromCity: x.paFromLocation?.city,
                //     toCityTons: x.tempCol.destinations?.reduce((a, b) => `${a} + ${b.tocityname}: ${b.tonnage}`, '')?.substr(3) + ' تن',
                //     tenderEndTarikh: x.tenderEndTarikh,
                //     statusName: x.statusName,
                //     truckTypes: x.truckTypes?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
                //     truckSpecs: x.truckSpecs?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
                //     companyNames: x.tempCol.companies?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3),
                //     loadingTimeFrom: x.tempCol.loadingTimeFrom,
                //     loadingTimeTo: x.tempCol.loadingTimeTo,
                //     fromProvinceId: 0,
                //     fromCityId: 0,
                //     destinations: x.tempCol.destinations,
                //     companies: x.tempCol.companies,
                //     companyIds: x.tempCol.companyIds,
                // }));

                // let orders = res.map(x => ({ ...x.loadOrder, ...x.tempCol, links: x.links }));
                // console.log(orders);
                resolve(res);
            })
            .catch(reject)

        // this.props.userId > 0 &&
        //     apiGetP(`/api/dyna/row/${role === 'orderer' ? 'loadOrderer' : role}?id=${this.props.userId}&field=summary`)
        //         .then(userText => this.setState({ userText }))
        //         .catch()
    });

    componentDidMount() {
        // Promise.all([this.loadEnumsP(), this.loadDataP()])
        //     .then(([enums, orders]) => {
        //         this.state.orders = orders;
        //         this.state.enums = enums;
        //     })
        //     .catch(window.notif)
        //     .finally(() => this.setState({ loading: false }));

        this.loadDataP()
            .then(orders => this.state.orders = orders)// this.setState({ orders }))
            .catch(window.notif)
            .finally(() => this.setState({ loading: false }));
    }

    renderUserName = () => {
        return (this.props.noUserName ? <></> :
            <div style={{ position: 'fixed', left: '1rem', top: '5px', /*opacity: '70%',*/ zIndex: 20, color: Theme.col0() }}>
                <Inline spacing='0.5rem'>
                    <FontAwesomeIcon icon='palette' fontSize='1.2rem' hint='تغییر تم'
                        onClick={
                            () => {
                                Theme.currThemeIndex = Theme.currThemeIndex < 0 ? 0 : -1;
                                window.reload();
                            }}
                    />
                    <div id='user-name-banner'>
                        {/* {`${this.props.userName ?? this.state.userText ?? `${window.user?.role}-${window.user?.userName}`}`} */}
                        {`${this.props.userName ?? ''} ${this.state.userText ?? ''}`}
                    </div>
                    <MinimalButton icon='fa-power-off' style={{ fontSize: '1.2em', width: '30px' }} highlightedColor='red'
                        onClick={() => this.props.onLogoff?.()}
                    />
                </Inline>
            </div>
        );
    }

    renderNewOrderButton = () => (
        this.state.userRole !== 'orderer' ? <></> :
            <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                <Button text='سفارش جدید' icon='plus' width='10rem' rtlEnabled
                    onClick={() => this.props.onAddNewOrderClicked?.()}
                />
            </div>
    );

    render() {
        if (this.state.loading)
            return (<Spinner />);

        if (!(this.state.orders?.length > 0))
            return (
                <h3 style={{
                    display: 'flex',
                    justifyContent: 'center',
                    color: 'lightgrey',
                    padding: '3rem',
                }}
                >
                    {'سفارشی در وضعیت ' + this.props.statusName + ' وجود ندارد'}
                </h3>
            );

        let allowEditOrder = ord => this.state.userRole === 'orderer' && ord.loadOrder.fK_OrderedBy === window.user.linkedrecord_rowid;
        let allowDeleteOrder = ord => this.state.userRole === 'orderer' && ord.loadOrder.fK_OrderedBy === window.user.linkedrecord_rowid;
        // let allowSelectOrder = ord => this.state.userRole === 'driver' && !ord.truckLinks.find(x => x.assignmentStatus === 5) // assigned
        //     || this.state.userRole === 'company' && !ord.companyLinks.find(x => x.assignmentStatus === 5); // assigned

        console.log('orders= ', this.state.orders, 'ordersBox enums=', this.state.enums);

        return (
            this.state.mode === 'grid'
                ?
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    {this.renderUserName()}
                    <Inline spacing='1rem'>
                        <Button text='نمایش کارتی' width='10rem' icon='mediumiconslayout' rtlEnabled
                            onClick={() => this.setState({ mode: 'cards' })}
                        />
                        {this.renderNewOrderButton()}
                    </Inline>

                    <UniGrid key={'grid_' + this.state.orders?.length + '_' + this.state.mode} width='95vw'
                        rows={this.state.orders?.map(x => ({ ...x.loadOrder, ...x.tempCol }))} readOnly showUniSettings={false}
                        multiSelect focusedRowEnabled={false}
                        //showFields={['name', 'comment', 'package']}
                        columns={[
                            { name: 'name', caption: 'عنوان' },
                            { name: 'comment', caption: 'توضیح' },
                            { name: 'package', caption: 'بسته بندی' },
                            {
                                name: 'pafromlocation', caption: 'مبدأ',
                                cellRender: c => c.row.data.pafromlocation?.city ?? ''
                            },
                            {
                                name: 'destinations', caption: 'مقصد',
                                cellRender: c => c.row.data.destinations?.reduce(
                                    (a, b) => a + (b.summary?.substr(0, b.summary?.length - 3) ?? `${b.auxCol?.toLocation?.city}: ${b.tonnage}`), '')
                                    + (c.row.data.destinations?.length > 0 ? ' تن' : '')
                            },
                            { name: 'tenderendtarikh', caption: 'مهلت مناقصه تا' },
                            {
                                name: 'loadingtimerange', caption: 'زمان بارگیری',
                                cellRender: c => 'از ' + c.row.data.loadingtarikhfrom + ' تا ' + c.row.data.loadingtarikhto
                            },
                            {
                                name: 'statusname', caption: 'وضعیت',
                                cellRender: c => {
                                    let assignedCompanies = c.row.data.assignedcompanies?.reduce((a, b) => a + ' | ' + b.name, '')?.substr(2) ?? '';
                                    if (assignedCompanies?.length > 0)
                                        return c.row.data.statusname + ': ' + assignedCompanies;

                                    return c.row.data.statusname ?? '';
                                }
                            },
                            {
                                name: 'trucktypes', caption: 'ناوگان',
                                cellRender: c => c.row.data.trucktypes?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3)
                            },
                            {
                                name: 'truckspecs', caption: 'مشخصات ناوگان',
                                cellRender: c => c.row.data.truckspecs?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3)
                            },
                            {
                                name: 'companies', caption: 'شرکت(ها)',
                                cellRender: c => c.row.data.companies?.reduce((a, b) => a + ' + ' + b.name, '')?.substr(3)
                            },
                        ]}
                    />
                </div>
                :
                <>
                    {/* {this.props.statusName?.length > 0 &&
                        <h3 style={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'grey',
                        }}
                        >{'سفارشات ' + this.props.statusName}
                        </h3>
                    } */}

                    <div style={{
                        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center',
                        background: Theme.col4(),
                    }}
                    >
                        <Inline spacing='1rem'>
                            <Button text='نمایش جدولی' width='10rem' onClick={() => this.setState({ mode: 'grid' })} rtlEnabled
                                icon='detailslayout'
                            />
                            {this.renderNewOrderButton()}
                        </Inline>
                    </div>

                    <div style={{
                        display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', direction: 'rtl',
                        background: Theme.col4(),
                    }}
                    >
                        {this.props.noUserName !== true && this.renderUserName()}
                        {this.state.orders?.map(x => (
                            <div key={'ordrc0_' + x.loadOrder?.id}>
                                <Inline key={'ordc_' + x.loadOrder?.id} className='loadorder-card'
                                    style={{ display: '-webkit-box', background: Theme.col0('transparent') }}
                                    spacing='2px'
                                >
                                    <div className='loadorder-card-command-bar'
                                        style={{ background: Theme.col4(), color: Theme.col2() }}
                                    >
                                        <MinimalButton style={{ margin: '1rem 0', }}
                                            highlightedBackground='transparent'
                                            highlightedColor={Theme.col0()}
                                            hint='تغییر اندازه'
                                            onClick={() => {
                                                x.collapsed = x.collapsed === false;
                                                this.forceUpdate();
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={x.collapsed !== false ? 'circle-chevron-down' : 'circle-chevron-up'}
                                                fontSize='1.5rem' type='solid'
                                            />
                                        </MinimalButton>

                                        {/* {allowSelectOrder(x) &&
                                            <MinimalButton style={{ margin: '1rem 0' }} hint={x.selected ? 'رد بار' : 'قبول بار'}
                                                highlightedBackground='transparent'
                                                highlightedColor={Theme.col0()}
                                                onClick={() => {
                                                    x.selected = !x.selected;
                                                    this.forceUpdate(() => this.props.onSelectionChanged?.(this.state.orders?.filter(x => x.selected)));
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={x.selected ? 'handshake-slash' : 'handshake'}
                                                    fontSize='1.5rem' type='solid' beat={!x.selected} // handshake-slash
                                                />
                                            </MinimalButton>
                                        } */}

                                        {allowEditOrder(x) &&
                                            <MinimalButton style={{ margin: '1rem 0' }} hint='ویرایش'
                                                highlightedBackground='transparent'
                                                highlightedColor={Theme.col0()}
                                                onClick={() => this.props.onEdit?.(x.loadOrder, x.tempCol, this.state.enums, this.state.userRole)}
                                            >
                                                <FontAwesomeIcon
                                                    icon='edit' fontSize='1.5rem' type='solid'
                                                />
                                            </MinimalButton>
                                        }
                                        {allowDeleteOrder(x) &&
                                            <MinimalButton style={{ margin: '1rem 0' }} hint='حذف'
                                                highlightedBackground='transparent'
                                                highlightedColor={Theme.col0()}
                                                onClick={() => this.props.onDelete?.(x.loadOrder?.id)}
                                            >
                                                <FontAwesomeIcon
                                                    icon='trash' fontSize='1.5rem' type='solid'
                                                />
                                            </MinimalButton>
                                        }
                                    </div>
                                    <LoadOrder {...x} readOnly userRole={this.state.userRole}
                                        width={this.props.cardWidth ?? (isMobile ? '90vw' : window.config.FULL_WIDTH_CARDS ? 'calc(90vw - 300px)' : '45rem')}
                                        collapsed={x.collapsed !== false}
                                    // onCanPutOfferChanged={(canPutOffer, yesno) => {
                                    // }}
                                    />
                                </Inline>
                            </div>
                        ))}
                    </div>
                </>
        );
    }
}

export default OrdersBoard;